import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../constants/firebaseModular';
import { SetInitialNavObjectResponse } from '../../types/Navigation/SetInitialNavObjectResponse';
import { SetInitialNavObjectPayload } from '../../types/Navigation/SetInitialNavObjectPayload';
import { doc, updateDoc } from 'firebase/firestore';
import * as Sentry from '@sentry/browser';

export const setInitialConciergeGuidedNavObject = async (patientId: string) => {
  // CALL CLOUD FUNCTION TO SET INITIAL NAV OBJECT FOR A SELF-GUIDED PATIENT ON THIS USER
  const postToCloudFunction = httpsCallable(functions, 'setInitialNavObject') as (
    // eslint-disable-next-line
    payload: SetInitialNavObjectPayload,
  ) => Promise<SetInitialNavObjectResponse>;
  const payload = {
    type: 'concierge',
    uid: patientId,
    // customRoutesGroup: "", // optional
  } as SetInitialNavObjectPayload;

  postToCloudFunction(payload)
    .then(async (response) => {
      if (response.data.status === 'error') {
        alert(`Error setting navigation object:  ${response.data.message}`);
        return;
      }
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      Sentry.captureException(error);
      console.error('Error calling cloud function', errorCode, errorMessage);
    });

  // UPDATE THE NAV TYPE IN THE PATIENTS USER DOC BASE
  const docRef = doc(db, 'users', patientId);
  await updateDoc(docRef, {
    navType: {
      base: 'concierge',
      // customRoutesGroup: '',
    },
  });
};
